import { render, staticRenderFns } from "./oops-component.vue?vue&type=template&id=0939ba22&scoped=true&"
import script from "./oops-component.vue?vue&type=script&lang=js&"
export * from "./oops-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0939ba22",
  null
  
)

export default component.exports